function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24 9.034L14.286 0v11.91L8.943 6.94 7 8.748 13.705 15 7 21.252l1.943 1.808 5.343-4.97V30L24 20.966 17.585 15 24 9.034zM20.357 9L16.717 12l-.003-6 3.643 3zm0 11.998L16.714 24l.003-6 3.64 2.999z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("mask", {
  id: "a",
  maskUnits: "userSpaceOnUse",
  x: "7",
  y: "0",
  width: "17",
  height: "30"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24 9.034L14.286 0v11.91L8.943 6.94 7 8.748 13.705 15 7 21.252l1.943 1.808 5.343-4.97V30L24 20.966 17.585 15 24 9.034zM20.357 9L16.717 12l-.003-6 3.643 3zm0 11.998L16.714 24l.003-6 3.64 2.999z",
  fill: "currentColor"
}))));